export const DeviceTypeIcons = {
    master_beacon: {
        icon: "fass fa-tower-broadcast",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"/></svg>',
        svg_path:
            "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z",
    },
    smart_beacon: {
        icon: "fass fa-tower-broadcast",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"/></svg>',
        svg_path:
            "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z",
    },
    tracking_beacon: {
        icon: "fass fa-tower-broadcast",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"/></svg>',
        svg_path:
            "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z",
    },
    gunshot_detector: {
        icon: "fass fa-tower-broadcast",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"/></svg>',
        svg_path:
            "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z",
    },
    camera: {
        icon: "fass fa-video",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400H64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 48c0 17.7 14.3 32 32 32s32-14.3 32-32V464h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zM513.4 398.6c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3L396.9 345.6l116.5 52.9z"/></svg>',
        // svg_path: "M384 64H0V448H384V64zM576 448V64L416 174.9V337.1L576 448z",
    },
    door: {
        icon: "fass fa-door-open",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M320 0L64 64V448H32 0v64H32 64 320V0zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480v32h32 64 32V448H544 512V96 64H480 352v64z"/></svg>',
        svg_path:
            "M320 0L64 64V448H32 0v64H32 64 320V0zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480v32h32 64 32V448H544 512V96 64H480 352v64z",
    },
    lockingdoor: {
        icon: "fass fa-lock",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h80V512H0V192H80z"/></svg>',
        svg_path:
            '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h80V512H0V192H80z"/></svg>',
    },

    first_aid_kit: {
        icon: "far fa-house-medical",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
        // svg_path: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
    },

    bleed_control_kit: {
        icon: "far fa-house-medical",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
        // svg_path: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
    },

    defibrillator: {
        icon: "far fa-house-medical",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
        // svg_path: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
    },

    choking_rescue_device: {
        icon: "far fa-house-medical",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
        // svg_path: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"/></svg>',
    },
};

// export const MarkerTypeIcons = {
//     master_beacon: {
//         icon: "fass fa-tower-broadcast",
//         icon_svg:
//             '<svg xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"/></svg>',
//         svg_path:
//             "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4V480v32H256V480 183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z",
//     },
// };

export const DeviceStatusIcons = {
    online: {
        icon: "fasl fa-plug-circle-check",
        // icon_svg: '',
        color: "green-500",
    },
    offline: {
        icon: "fasl fa-triangle-exclamation",
        // icon_svg: '',
        color: "orange-500",
    },
    error: {
        icon: "fasl fa-plug-circle-xmark",
        // icon_svg: '',
        color: "red-500",
    },
    unconfigured: {
        icon: "fasl fa-plug",
        // icon_svg: '',
        color: "grey-500",
    },
};

export const EndUserTypeIcons = {
    civilian: {
        icon: "far fa-user",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>',
    },
    security: {
        icon: "far fa-user-police",
        icon_svg:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM134.4 352c2.8 0 5.5 .9 7.7 2.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zM352 408c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z"/></svg>',
    },
    // Device-type variants for end-user map markers (CV-1551). The marker
    // template renders the `icon` class; solid (`fas`) to match the existing
    // solid user glyph painted white inside `.marker-icon-round`. Both icons
    // MUST be registered in src/plugins/fontawesome.js — tree-shaken FA only
    // renders icons added to the library (fa-user and fa-id-badge are).
    // Phone (non-wearable) users keep the original solid user glyph; only
    // wearables get a distinct id-badge glyph.
    phone: {
        icon: "fas fa-user",
        // icon_svg: '',
    },
    wearable: {
        icon: "fas fa-id-badge",
        // icon_svg: '',
    },
};

export const ExposureLevelColors = {
    red: { color: "corridor-red-500" },
    orange: { color: "corridor-orange-500" },
    green: { color: "corridor-green-500" },
    black: { color: "gray-900" },
    blue: { color: "corridor-blue-500" },
    unknown: { color: "gray-500" },
};

export const MarkerTypeIcons = {
    fire: {
        icon: "far fa-fire",
    },
    smoke: {
        icon: "far fa-smoke",
    },
    gunshot: {
        icon: "far fa-burst",
    },
    medical: { icon: "far fa-kit-medical" },

    behaviour: {
        icon: "far fa-face-frown",
    },
};

export const IncidentTypeIcons = {
    fire: {
        icon: "far fa-fire",
        svg: "/assets/icons/icon-incident-fire-white.svg",
    },
    shooter: {
        icon: "far fa-gun",
        svg: "/assets/icons/icon-incident-shooter-white.svg",
    },
    medical: {
        icon: "far fa-kit-medical",
        svg: "/assets/icons/icon-incident-medical-white.svg",
    },
    behaviour: {
        icon: "far fa-face-frown",
        svg: "/assets/icons/icon-incident-behaviour-white.svg",
    },
    weather: {
        icon: "far fa-cloud-bolt",
        svg: "/assets/icons/icon-incident-weather-white.svg",
    },
};

export const IncidentStatusIcons = {
    unconfirmed: { color: "orange-500", icon: "fas fa-square-question" },
    confirmed: {
        color: "red-500",
        icon: "fas fa-triangle-exclamation",
    },
    resolved: { color: "blue-500", icon: "fas fa-square-check" },
};

export const IncidentSeverityIcons = {
    1: {
        color: "red-500",
        color1: "red-50",
        icon: "far fa-triangle-exclamation",
    },
    2: {
        color: "orange-500",
        color1: "orange-50",
        icon: "far fa-triangle-exclamation",
    },
    3: {
        color: "yellow-500",
        color1: "yellow-50",
        icon: "far fa-triangle-exclamation",
    },
};

export const TaskStatusIcons = {
    unconfirmed: { color: "gray-500", icon: "fas fa-square-question" },
    confirmed: {
        color: "red-500",
        icon: "fas fa-triangle-exclamation",
    },
    resolved: { color: "blue-500", icon: "fas fa-square-check" },
};

export const LATITUDE_REGEX =
    /^(\+|-)?(?:90(?:(?:\.0{1,14})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,14})?))$/;
export const LONGITUDE_REGEX =
    /^(\+|-)?(?:180(?:(?:\.0{1,14})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,14})?))$/;
export const MACADDRESS_REGEX =
    /^[0-9a-fA-F]{2}([:])(?:[0-9a-fA-F]{2}\1){4}[0-9a-fA-F]{2}$/;
export const UUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export const IPADDRESS_REGEX =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const DATATABLE_COLUMN_SORT_NONE = 0;
export const DATATABLE_COLUMN_SORT_ASCENDING = 1;
export const DATATABLE_COLUMN_SORT_DESCENDING = -1;

export const API_SORT_ASCENDING = "asc";
export const API_SORT_DESCENDING = "desc";

export const IncidentSeverityOrder = [
    { value: "critical", level: 1 },
    { value: "major", level: 2 },
    { value: "high", level: 3 },
    { value: "hazardous", level: 4 },
    { value: "unknown", level: 50 },
    { value: "safe", level: 98 },
    { value: "offsite", level: 99 },
];

export const ExposureColourToSeverity = {
    red: "danger",
    orange: "warn",
    green: "success",
    black: "secondary",
    blue: "info",
};

export const IncidentEventTypes = [
    {
        event_type: "notification_sent",
    },
    {
        event_type: "incident_confirmed",
    },
    {
        event_type: "safezones_validated",
    },
];


/**
 * Appearance for space-name labels on the map.
 * Used by MappedInMapComponent and MappedInInstallerComponent.
 *
 * MappedIn v5 reads label appearance as `{ text: { size, foregroundColor } }`,
 * so it ignores these keys and draws its default labels (11.5 px). The
 * Corridor map engine applies `fontSize` and `color`; `fontSize` matches
 * MappedIn's default so both engines show the same size. `font` is unused:
 * Corridor labels use the map's own glyph font.
 */
export const MAPPEDIN_SPACE_LABEL_APPEARANCE = {
    font: "Georgia",
    fontSize: 11.5,
    color: "#1c1c43",
};

/**
 * Installer map: default space label (same size as main app). Used by MappedInInstallerComponent.
 */
export const MAPPEDIN_INSTALLER_LABEL_DEFAULT = {
    text: {
        size: 16,
        foregroundColor: "#1c1c43",
    },
};

/**
 * Installer map: fill color for the floor polygon when a space is selected (hex).
 * Also used for operator map End Users space filter highlight (same UX).
 */
export const MAPPEDIN_INSTALLER_SELECTED_POLYGON_COLOR = "#93c5fd";

// Set to true to show beacon markers on all levels (dimmed at 30% opacity when not on current level).
// When false (default), beacons are hidden on levels other than the currently selected one.
export const SHOW_BEACONS_ON_ALL_LEVELS = false;

/**
 * Installer map: selected space label (bigger font + blue). Used by MappedInInstallerComponent.
 */
export const MAPPEDIN_INSTALLER_LABEL_SELECTED = {
    text: {
        size: 24,
        foregroundColor: "#2563eb",
    },
};
